import React from 'react';

import { Box } from '@mui/material';

import InlineLoadingIndicator from '@common/components/loading-indicator/inline-loading-indicator';

const IframeLoadingWrapper = ({ isIframeLoaded, children }) => {
  return (
    <Box sx={{ flex: 'auto', height: '100%' }}>
      <Box
        sx={{
          // Here to prevent view from jumping around on load
          display: !isIframeLoaded ? 'block' : 'none',
          width: '100%',
          height: '100%'
        }}
      >
        <InlineLoadingIndicator backgroundColor="transparent" />
      </Box>
      <Box
        sx={{
          // Here to prevent view from jumping around on load
          display: !isIframeLoaded ? 'none' : 'block',
          width: '100%',
          height: '100%',
          overflow: 'hidden'
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default IframeLoadingWrapper;
